import { computed } from 'mobx';
import { ContainerBlock } from '~/models/blocks/container-block.model';
import type { QuestionBlock } from '~/models/blocks/question-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';
import { QuestionType } from '~/types/builder.types';
import { ILeadDetailsBlockResponse } from '~/types/server.types';

type LeadsDetailsBlockDataForServer = ReturnType<
    ContainerBlock['getDataForServer']
> &
    Pick<ILeadDetailsBlockResponse, 'type'>;

export class LeadDetailsBlock extends ContainerBlock {
    type: 'lead_details_block';

    constructor(
        block: ILeadDetailsBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get maxAllowedColumns() {
        return 2;
    }

    get isDeletable() {
        return false;
    }

    @computed
    get label() {
        return 'Contact info';
    }

    @computed
    get shouldExpandOnSelect() {
        return false;
    }

    @computed
    get allQuestionBlocks() {
        return this.allDescendants().filter(
            block =>
                block.isQuestionBlock() &&
                block.question.question_type === QuestionType.ShortText
        ) as QuestionBlock[];
    }

    @computed
    get clientEmailQuestionBlock() {
        return this.allQuestionBlocks.find(
            blk => blk.question.validation_type === 'email'
        );
    }

    getDataForServer(): LeadsDetailsBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'lead_details_block'
        };
    }
}
